import { ResultProcess } from './models/resultProcess';
import { Component, OnInit } from '@angular/core';
import { LabMDM, SelectableLab } from './models/lab';
import { CarrierState } from './models/carrierState';
import { Machine } from './models/machine';
import { BusinessArea } from './models/businessArea';
import { MasterDataService } from './masterdata.service';
import { ErrorHandler } from "../utils/error-handler"
import { MessagesService } from '../messages/messages.service';
import { MasterList } from './masterList-enum';
import { SeqConfig } from './models/seqConfig';
import { SelectItem } from 'primeng/api/selectitem';
import { Chemical } from './models/chemical';
import { SelectableHazardousType } from './selectable-hazardoustype';
import { SelectableAssayType } from './models//SelectableAssayType';
import { AssayType } from './models/assayType-enum';
import { HazardousType } from './hazardousType-enum';
import { Printer } from './models/printer';
import { MachineType } from './models/machineType';
import { Product } from './models/product';
import { BmsProductName } from './models/BmsProductName';
import { LibType } from './models/libType';
import { EchoConfig } from './models/echoConfig';
import { SalesItemTypeConfig } from './models/salesitemtype-config';
import { StandardPrimer } from './models/standardPrimer';
import { Template } from './models/template';
import { SenderDTO } from './models/sender-dto';
import { KitsDTO } from './models/kits-dto';
import { ProblemCategoryDTO } from './models/problemCategory';
import { ProblemDTO } from './models/problem';
import { LabEmitterService } from '../common-services/lab-emitter.service';
import { ResultConfigDTO } from '../mdm-result-engine-config/model/result-config-dto';
import { ExternalSenderLoginDTO } from './models/externalSenderLogin';
import { Manufacturers } from './models/manufacturers';
import { Tags } from './models/tags';
import { TagSystem } from './models/tag-system';
import { WorkFlow } from './models/workflow';
import { SnpProfile } from './models/snp-profile';
import { FlowCell } from './models/flowcell';
import { Analysis } from './models/analysis';
import { Process } from './models/process';
import { ProcessType } from './models/processtype';
import { Station } from './models/station';
import { InboundFileProcessing } from './models/InboundFileProcessing';
import { LibraryConfiguration } from './models/libraryConfiguration';
import { Workfile } from './models/workfile';
import { StepCategory } from './models/stepCategory';


@Component({
  selector: 'app-masterdata',
  templateUrl: './masterdata.component.html',
  styleUrls: ['./masterdata.component.css']
})
//This component is used to display the various lisst of master data. This is the parent of the crud table component.
//The data regarding the feilds to disaply in the crud table is sent to the child component.
export class MasterdataComponent implements OnInit {

  countries: SelectItem[];
  statusCols: any[];
  labCols: any[];
  machineCols: any[];
  printerCols: any[];
  baCols: any[];
  seqConfigCols: any[];
  chemicalCols: any[];
  machineTypesCols: any[];
  productCols: any[];
  workFlowCols: any[];
  accessLogsCols: any[];
  libTypeCols: any[];
  echoConfigCols: any[];
  sitConfigCols: any[];
  standardPrimerCols: any[];
  templateCols: any[];
  senderCols: any[];
  kitCols: any[] = [];
  kitDetailCols: any[] = [];
  labs: LabMDM[] = [];
  machines: Machine[] = [];
  printers: Printer[] = [];
  states: CarrierState[] = [];
  businessAreas: BusinessArea[] = [];
  seqConfigs: SeqConfig[] = [];
  chemicals: Chemical[] = [];
  machineTypes: MachineType[];
  products: Product[] = [];
  libTypes: LibType[] = [];
  workFlow: WorkFlow[] = [];
  echoConfigs: EchoConfig[] = [];
  sitConfigs: SalesItemTypeConfig[] = [];
  standardPrimers: StandardPrimer[] = [];
  templates: Template[] = [];
  senders: SenderDTO[] = [];
  kits: KitsDTO[] = [];
  problemCategories: ProblemCategoryDTO[] = [];
  problemCategoriesCols: any[];
  resultProcessCols: any[];
  resultEngineConfigCols: any[];
  problem: ProblemDTO[] = [];
  resultProcess: ResultProcess[] = [];
  resultConfigList: ResultConfigDTO[] = [];
  problemCols: any[];
  labTitle: string = "Labs";
  workFlowTitle: string = "Workflow "
  machineTitle: string = "Machines";
  printerTitle: string = "Printers";
  processStepTitle: string = "Process Step";
  baTitle: string = "Business Areas";
  seqConfigTitle: string = "Sequencer Configurations";
  chemicalTitle: string = "Chemicals";
  machineTypesTitle: string = "Machine Types"
  productTitle: string = "Products"
  libTypeTitle: string = "LibTypes"
  echoConfigTitle: string = "Echo Configurations";
  sitConfigTitle: string = "Sales Item Types";
  standardPrimerTitle: string = "Standard Primers";
  templateTitle: string = "Barcode Templates";
  senderTitle: string = "Sender Templates";
  kitsTitle: string = "Kits Configuration"
  problemCategoryTitle: string = "Problem Category "
  problemTitle: string = "NC-Problem"
  resultProcessTitle: string = "Result-Process"
  resultEngineConfigTitle: string = "Result Logic"
  labType = MasterList.LAB;
  machineType = MasterList.MACHINE;
  printerType = MasterList.PRINTER;
  baType = MasterList.BUSINESS_AREA;
  statusType = MasterList.CARRIER_STATUS;
  seqConfigType = MasterList.SEQUENCER_CONFIG;
  chemicalType = MasterList.CHEMICAL;
  machineTypeList = MasterList.MACHINE_TYPE;
  productType = MasterList.PRODUCT;
  libType = MasterList.LIB_TYPE;
  echoConfigType = MasterList.ECHO_CONFIGURATION;
  sitConfigType = MasterList.SALES_ITEM_TYPE;

  labOptions: LabMDM[] = [];
  baOptions: BusinessArea[] = [];
  machineTypesOptions: MachineType[] = [];
  hazardousTypeOptions: SelectableHazardousType[] = [];
  assayTypeOptions: SelectableAssayType[] = [];
  errorHandler: ErrorHandler = new ErrorHandler;

  bufferChemicalOptions: Chemical[];
  sitConfigOptions: SalesItemTypeConfig[] = [];
  bmsProductNames: BmsProductName[] = [];
  printerOptions: Printer[] = [];
  processStepOptions: SelectItem[];
  productOptions: Product[] = [];
  templateOptions: Template[] = [];
  workFlowOptions: WorkFlow[] = [];
  loading: boolean;
  respose: any;
  health: any;
  healthCols: any[];
  accessLog: any;
  selectedLab: SelectableLab;

  maxRedoValues: SelectItem[];
  reactionOptionValues: SelectItem[];
  //Config for Machine Manufacturer Config
  manufacturerConfigTitle = "Machine Manufacturer";
  manufacturerConfigCols: any[];
  manufacturersList: Manufacturers[];

  externalSenderLogins: ExternalSenderLoginDTO[];
  externalSenderLoginTitle: string = "External Sender Login Templates";
  externalSenderLoginCols: any[];

  tags: Tags[];
  tagsTitle: string = "Tag Plate";
  tagCols: any[];
  mapOfTags = new Map();
  tagPlates: string[];
  workFlows: string[];

  tagSystem: TagSystem[];
  tagSystemTitle: string = "Tag System";
  tagSystemCols: any[];
  tagSystems: string[];

  snpProfile: SnpProfile[] = [];
  snpProfileTitle: string = "SNP Profile"
  snpProfileCols: any[];

  flowCell: FlowCell[] = [];
  flowCellTitle: string = "Flow Cells";
  flowCellCols: any[];


  analysis: Analysis[] = [];
  analysisTitle: string = "Analysis";
  analysisCols: any[];

  process: Process[] = [];
  processOptions: any[] = [];
  processTitle: string = "Process";
  processCols: any[];

  processType: ProcessType[] = [];
  processTypeTitle: string = "Process Type";
  processTypeCols: any[];

  station: Station[] = [];
  stationTitle: string = "Station";
  stationCols: any[];

  inBoundFile: InboundFileProcessing[] = [];
  inBoundFileTitle: string = "Inbound File Processing";
  inBoundFileCols: any[];

  libConfigFile: LibraryConfiguration[] = [];
  libConfigCols: any[];


  workFiles: Workfile[] = [];
  workFilesTitle: string = "Workfiles";
  workFilesCols: any[];

  stepCategories: StepCategory[] = [];
  stepCategoryTitle: string = "Step Category";
  stepCategoryCols: any[];

  selectedOption: string = null;

  readonly PROCESS_STEP = "Process Step";
  readonly BUSINESS_AREAS = "Business Areas";
  readonly SEQUENCER_CONFIGURATION = "Sequencer Configurations";
  readonly MACHINE_TYPE = "Machine Types";
  readonly ECHO_CONFIGURATINS = "Echo Configurations";
  readonly SALES_ITEM_TYPES = "Sales Item Types";
  readonly STANDARD_PRIMERS = "Standard Primers";
  readonly BARCODE_TEMPLATES = "Barcode Templates";
  readonly PROBLEM_CATEGORY = "Problem Category";
  readonly RESULT_PROCESS = "Result-Process";
  readonly RESULT_LOGIC = "Result Logic";
  readonly MACHINE_MANUFACTURER = "Machine Manufacturer";
  readonly TAG_SYSTEM = "Tag System";
  readonly SNP_PROFILE = "SNP Profile";
  readonly FLOW_CELLS = "Flow Cells";
  readonly PROCESS_TYPE = "Process Type";
  readonly INBOUND_FILE_PROCESSING = "Inbound File Processing";
  readonly STEP_CATEGORY = "Step Category";
  readonly ACCESS_LOGS = "Access Logs";
  readonly QC_PROBLEM = "QC Problem";
  readonly SENDER_EXTERNAL_CONFIGURATIONS = "Sender External Configurations";
  readonly TAG_PLATES = "Tag Plates";

  dropdownOptions: any[] = [
    { label: this.BUSINESS_AREAS, value: this.BUSINESS_AREAS },
    { label: 'Labs', value: 'Labs' },
    { label: this.MACHINE_TYPE, value: this.MACHINE_TYPE },
    { label: 'Machines', value: 'Machines' },
    { label: 'Printers', value: 'Printers' },
    { label: this.PROCESS_STEP, value: this.PROCESS_STEP },
    { label: this.SEQUENCER_CONFIGURATION, value: this.SEQUENCER_CONFIGURATION },
    { label: 'Products', value: 'Products' },
    { label: 'Chemicals', value: 'Chemicals' },
    { label: 'Health', value: 'Health' },
    { label: this.ACCESS_LOGS, value: this.ACCESS_LOGS },
    { label: 'LibTypes', value: 'LibTypes' },
    { label: this.ECHO_CONFIGURATINS, value: this.ECHO_CONFIGURATINS },
    { label: this.SALES_ITEM_TYPES, value: this.SALES_ITEM_TYPES },
    { label: this.STANDARD_PRIMERS, value: this.STANDARD_PRIMERS },
    { label: this.BARCODE_TEMPLATES, value: this.BARCODE_TEMPLATES },
    { label: 'Senders', value: 'Senders' },
    { label: 'Kits', value: 'Kits' },
    { label: this.PROBLEM_CATEGORY, value: this.PROBLEM_CATEGORY },
    { label: this.QC_PROBLEM, value: this.QC_PROBLEM },
    { label: this.RESULT_PROCESS, value: this.RESULT_PROCESS },
    { label: this.RESULT_LOGIC, value: this.RESULT_LOGIC },
    { label: this.MACHINE_MANUFACTURER, value: this.MACHINE_MANUFACTURER },
    { label: this.SENDER_EXTERNAL_CONFIGURATIONS, value: this.SENDER_EXTERNAL_CONFIGURATIONS },
    { label: this.TAG_SYSTEM, value: this.TAG_SYSTEM },
    { label: this.TAG_PLATES, value: this.TAG_PLATES },
    { label: 'Work Flow', value: 'Work Flow' },
    { label: this.SNP_PROFILE, value: this.SNP_PROFILE },
    { label: this.FLOW_CELLS, value: this.FLOW_CELLS },
    { label: 'Analysis', value: 'Analysis' },
    { label: 'Process', value: 'Process' },
    { label: this.PROCESS_TYPE, value: this.PROCESS_TYPE },
    { label: 'Station', value: 'Station' },
    { label: this.INBOUND_FILE_PROCESSING, value: this.INBOUND_FILE_PROCESSING },
    { label: 'Workfiles', value: 'Workfiles' },
    { label: this.STEP_CATEGORY, value: this.STEP_CATEGORY }
  ];

  constructor(private _masterDataService: MasterDataService, private _messageService: MessagesService
    , private _labEmitterService: LabEmitterService) {

  }

  ngOnInit() {

    this._labEmitterService.change.subscribe(lab => {
      this.selectedLab = lab;
      console.log("Seleted lab in masterData(e): " + this.selectedLab.label)
    });
    this.selectedLab = JSON.parse(localStorage.getItem('lab'));
    this.dropdownOptions.sort((a, b) => a.label.localeCompare(b.label));

    //Used for displaying the lab values in the crud table
    this.labCols = [
      { field: 'name', header: 'Lab Name' },
      { field: 'mix2SeqLabId', header: 'Mix2Seq Lab ID' },
      { field: 'productionLab', header: 'One-IT Lab ID (BMS compatible)' },
      { field: 'businessArea', header: 'BusinessArea', sort: 'businessArea.name' },
      { field: 'countryName', header: 'Country' },
      { field: 'dateFormat', header: 'Date Format' },
      { field: 'dateTimeFormat', header: 'Date Time Format' },
      { field: 'workfileNameFormat', header: 'File Date Time Format' },
      { field: 'city', header: 'City' },
      { field: 'numberOfPC', header: 'Number Of PC' },
      { field: 'numberOfNC', header: 'Number Of NC' },
      { field: 'numberOfPositivePCRControls', header: 'Number positive PCR Controls ', display: 'none' },
      { field: 'numberOfNegativePCRControls', header: 'Number negative PCR Controls', display: 'none' },
      { field: 'manager', header: 'Lab Manager' },
      { field: 'defaultLanguage', header: 'Default Language' },
      { field: 'unboxingInBatches', header: 'Unboxing in batches', display: 'none' },
      { field: 'reportingOutsideBB', header: 'Reporting done outside BB', display: 'none' },
      { field: 'clippingMachine', header: 'Clipping Machine (create batch by upload)', display: 'none' },
      { field: 'reducedConfirmationTests', header: 'Reduced Confirmation Tests', display: 'none' },
      { field: 'flaTestProcess', header: 'FLA Process', display: 'none' },
      { field: 'batchIDRegex', header: 'Check BatchID with regex', display: 'none' },
      { field: 'active', header: 'Active' }
    ];
    //Used for displaying manufacturer config values
    this.manufacturerConfigCols = [
      { field: 'manufacturerName', header: 'Name' },
      { field: 'machineType', header: 'Machine Type' },
      { field: 'active', header: 'Active' }
    ];
    //Used for displaying the machine values in the crud table
    this.machineCols = [
      { field: 'name', header: 'Name' },
      { field: 'barcode', header: 'Barcode' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'type', header: 'Machine Type', sort: 'type.name' },
      { field: 'hostAddress', header: 'Host Address', width: '20%' },
      { field: 'subType', header: 'Sub Type' },
      { field: 'fileType', header: 'File Type' },
      { field: 'ioCapacity', header: 'In/Out Capacity' },
      { field: 'manufacturer', header: 'Manufacturer' },
      { field: 'active', header: 'Active', width: '5%' }
    ];
    //Used for displaying the printer values in the crud table
    this.printerCols = [
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'name', header: 'Name' },
      { field: 'ipAddress', header: 'Host Address' },
      { field: 'port', header: 'Port' },
      { field: 'printEnabled', header: 'Print Enabled' },
      { field: 'defaultPrinter', header: 'Default Printer' },
      { field: 'active', header: 'Active' },
      { field: 'template', header: 'Default Template' }
    ];
    //Used for displaying the status values in the crud table
    this.statusCols = [
      { field: 'name', header: 'Step Name' },
      { field: 'stepDisplayName', header: 'Step Display Name' },
      { field: 'sortingName', header: 'Sorting Name' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'process', header: 'Process Name' },
      { field: 'station', header: 'Station Name' },
      { field: 'machineType', header: 'Machine Type' },
      { field: 'nextStep', header: 'Next Step' },
      { field: 'workfileDefinition', header: 'Workfile Definition' },
      { field: 'qctype', header: 'QC Type' },
      { field: 'sourcePlatePrefixes', header: 'Source Plate Prefixes' },
      { field: 'platePrefixes', header: 'Target Plate Prefixes' },
      { field: 'storagePlatePrefix', header: 'Storage Plate Prefix' },
      { field: 'specialHandlerList', header: 'Special Handling' },
      { field: 'qcEvaluationStepList', header: 'Steps with QC Data for QC Evaluation in this Step' },
      { field: 'nextStepForQCNotCompleted', header: 'Next Step for QC not complete' },
      { field: 'nextStepForQCPassed', header: 'Next Step for QC passed' },
      { field: 'nextStepForQCFailed', header: 'Next Step for QC failed' },
      { field: 'printer', header: 'Printer' },
      { field: 'defaultTemplate', header: 'Default Template' },
      { field: 'processList', header: 'Process List Active' },
      { field: 'active', header: 'Active' }
    ];
    //Used for displaying the ba values in the crud table
    this.baCols = [
      { field: 'name', header: 'Business Area' },
      { field: 'active', header: 'Active' },
    ];

    //Used for displaying the Seq Config values in the crud table
    this.seqConfigCols = [
      { field: 'description', header: 'Description' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'product', header: 'ProductType' },
      { field: 'application', header: 'Application' },
      { field: 'containerType', header: 'ContainerType' },
      { field: 'owner', header: 'Owner' },
      { field: 'operator', header: 'Operator' },
      { field: 'plateSealing', header: 'PlateSealing' },
      { field: 'resultsGroup', header: 'ResultsGroup' },
      { field: 'instrumentProtocol1', header: 'Instrument Protocol1' },
      { field: 'analysisProtocol1', header: 'Analysis Protocol1' },
      { field: 'active', header: 'Active' }
    ];

    this.chemicalCols = [
      { field: 'name', header: 'Name' },
      { field: 'barcode', header: 'Barcode' },
      { field: 'lab', header: 'Lab' },
      { field: 'originalVolume', header: ' Orignal Volume' },
      { field: 'remainingVolume', header: 'Remaining Volume' },
      { field: 'hazardousType', header: 'Hazardous Type' },
      { field: 'category', header: 'Category' },
      { field: 'active', header: 'Active' },
    ];

    //Used to displaying the product in crude table
    this.productCols = [
      { field: 'name', header: 'Product Type' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'workflow', header: 'Work Flow' },
      { field: 'snpProfile', header: 'SNP Profile Name' },
      { field: 'salesItemType', header: 'Sales Item Type' },
      { field: 'tagSystem', header: 'Tag system' },
      { field: 'requiredRead', header: 'Required Read' },
      { field: 'premixed', header: 'Premixed' },
      { field: 'active', header: 'Active' }
    ];

    this.workFlowCols = [
      { field: 'workFlowName', header: 'Workflow Name' },
      { field: 'workflowGroup', header: 'Workflow Group' },
      { field: 'processScale', header: 'Process Scale' },
      { field: 'mergeInStatus', header: 'Merge in Status' },
      { field: 'statusAfterMerge', header: 'Status after merge' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'active', header: 'Active' }
    ];

    //Used for displaying the machine Type values in the crud table
    this.machineTypesCols = [
      { field: 'name', header: 'Name' },
      { field: 'description', header: 'Description' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'liquidHandling', header: 'Liquid Handling' },
      { field: 'measurements', header: 'Measurements' },
      { field: 'scanner', header: 'Scanner' },
      { field: 'sequencer', header: 'Sequencer' },
      { field: 'active', header: 'Active' },
    ];

    this.healthCols = [
      { field: 'name', header: 'Service' },
      { field: 'healthcheckresult', header: 'Status' }
    ];

    //Used to displaying the product in crude table
    this.libTypeCols = [
      { field: 'name', header: 'Name' },
      { field: 'buffer', header: 'Buffer', sort: 'buffer.name' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'targetVolume', header: 'Target Volume' },
      { field: 'minConc', header: 'Min Conc' },
      { field: 'maxConc', header: 'Max Conc' },
      { field: 'assayType', header: 'Assay Type' },
      { field: 'fragmentAnalyserConc', header: 'Fragment Analyser Conc' },
      { field: 'dilution_d', header: 'dilution_d' },
      { field: 'dilution_c', header: 'dilution_c' },
      { field: 'dilution_b', header: 'dilution_b' },
      { field: 'default', header: 'Default' },
      { field: 'active', header: 'Active' },
    ];

    this.hazardousTypeOptions = [
      { label: 'Acute Toxicity', hazardousType: HazardousType.ACUTE_TOXICITY },
      { label: 'Aspiration Hazard', hazardousType: HazardousType.ASPIRATION_HAZARD },
      { label: 'Compressed Gases', hazardousType: HazardousType.COMPRESSED_GASES },
      { label: 'Corrosive', hazardousType: HazardousType.CORROSIVE },
      { label: 'Explosives', hazardousType: HazardousType.EXPLOSIVES },
      { label: 'Flamable Liquids', hazardousType: HazardousType.FLAMMABLE_LIQUIDS },
      // { label: 'Hazardous To Aquatic Environment', hazardousType: HazardousType.HAZARDOUS_TO_THE_AQUATIC_ENVIRONMENT },
      { label: 'Oxidising Liquids', hazardousType: HazardousType.OXIDISING_LIQUIDS },
      { label: 'Toxic Irration', hazardousType: HazardousType.TOXIC_IRRATION },
    ];

    this.assayTypeOptions = [
      { label: 'HS Large Fragment', assayType: AssayType.HS_LARGE_FRAGMENT },
      { label: 'HS NGS Fragment', assayType: AssayType.HS_NGS_FRAGMENT },
      { label: 'SS NGS Fragment', assayType: AssayType.SS_NGS_FRAGMENT },
      { label: 'SS NGS RNA Fragment', assayType: AssayType.SS_NGS_RNA_Fragment },
      { label: 'HS NGS RNA Fragment', assayType: AssayType.HS_NGS_RNA_Fragment },
      { label: 'No Assay Type', assayType: AssayType.NO_ASSAY_TYPE }
    ];


    //used to display the access log values
    this.accessLogsCols = [
      { field: 'puid', header: 'PUID' },
      { field: 'loginTime', header: 'Login Time' },
      { field: 'logoutTime', header: 'Logout Time' }
    ];

    //Used for displaying the Echo Config values in the crud table
    this.echoConfigCols = [
      { field: 'product', header: 'Product Type' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'reactionOptionProtocol', header: 'Reaction options' },
      { field: 'masterMixBarcode', header: 'Master Mix Barcode' },
      { field: 'masterMixPlateType', header: 'Master Mix PlateType' },
      { field: 'masterMixVolume', header: 'Master Mix Volume' },
      { field: 'sourcePlateType', header: 'Source Plate Type' },
      { field: 'sampleVolume', header: 'Sample Volume' },
      { field: 'standardPrimerVolume', header: 'Standard Primer Volume' },
      { field: 'synthesizedPrimerVolume', header: 'Synthesized Primer Volume' },
      { field: 'enclosedPrimerVolume', header: 'Enclosed Primer Volume' },
      { field: 'active', header: 'Active' }
    ];

    this.sitConfigCols = [
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'sitKey', header: 'Sales Item Type' },
      { field: 'bmsKitProductName', header: 'BMS Kit Product Name', sort: 'bmsKitProductName.name' },
      { field: 'bmsTubeProductName', header: 'BMS Tube Product Name', sort: 'bmsKitProductName.name' },
      { field: 'jobTime', header: 'Job Time' },
      { field: 'maxRedo', header: 'Max Redo' }
    ];

    this.standardPrimerCols = [
      { field: 'primerName', header: 'Primer Name' },
      { field: 'sequence', header: 'Sequence' },
      { field: 'primerID', header: 'Primer ID' },
      { field: 'tm', header: 'Tm °C' },
      { field: 'gc', header: 'GC %' },
      { field: 'qcPrimer', header: 'QC Primer' },
      { field: 'active', header: 'Active' }
    ];

    this.templateCols = [
      { field: 'templateName', header: 'Template Name' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'entity', header: 'Entity' },
      { field: 'width', header: 'Width' },
      { field: 'height', header: 'Height' },
      { field: 'numberOfParallelLanes', header: 'Number of parallel lanes' },
      { field: 'active', header: 'Active' },
    ];


    this.senderCols = [
      { field: 'senderName', header: 'Sender Name', width: '10%' },
      { field: 'senderShortName', header: 'Short Name' },
      { field: 'senderGroupName', header: 'Sender Group Name ' },
      { field: 'lab', header: 'Lab' },
      { field: 'barcodeFormat', header: 'Barcode Format' },
      { field: 'trfBarcode', header: 'TRF Barcode' },
      { field: 'trfFormat', header: 'TRF Format' },
      { field: 'boxBarcode', header: 'Box Barcode' },
      { field: 'boxBarcodeFormat', header: 'Box Barcode Format' },
      { field: 'externalSampleBarcode', header: 'Scan Ext Sample Barcode' },
      { field: 'regionalCodes', header: 'External Sample Format' },
      { field: 'checkForIdentity', header: 'Check For Identity' },
      { field: 'mergeGroup', header: 'Merge Group' },
      { field: 'barcodeValidationRequired', header: 'DB Exist. Check Req?', width: '4%' },
      { field: 'dataFormat', header: 'Data Format' },
      { field: 'contactID', header: 'Contact ID' },
      { field: 'barcodeExistOnBag', header: 'Is Bar code On Bag', width: '3%' },
      { field: 'swabType', header: 'Swab Type', width: '4%' },
      { field: 'storageTime', header: 'Storage Time For NC Samples (days)' },
      { field: 'defaultPriority', header: 'Default Priority', width: '4%', display: 'none' },
      { field: 'allowedPCRKits', header: 'Allowed PCR Kits', display: 'none' },
      { field: 'allowedExtractionKits', header: 'Allowed Extractor Kits', display: 'none' },
      { field: 'allowedCyclerTypes', header: 'Allowed Cycler Types', display: 'none' },
      { field: 'allowedExtractorTypes', header: 'Allowed Extractor Types', display: 'none' },
      { field: 'active', header: 'Active', width: '4%' },
      { field: 'categoryType', header: this.PROBLEM_CATEGORY, display: 'none' }
    ]

    this.kitCols = [
      { field: 'kitName', header: 'Kit Name' },
      { field: 'lab', header: 'Lab' },
      { field: 'kitType', header: 'Kit Type' },
      { field: 'requiredMaterials', header: 'Required Materials' },
      { field: 'swabRestriction', header: 'Swab Restriction' },
      { field: 'channel1Gene', header: 'Channel 1-Gene' },
      { field: 'channel1File', header: 'Channel 1-File' },
      { field: 'channel1Dye', header: 'Channel 1-Dye' },
      { field: 'channel2Gene', header: 'Channel 2-Gene' },
      { field: 'channel2File', header: 'Channel 2-File' },
      { field: 'channel2Dye', header: 'Channel 2-Dye' },
      { field: 'channel3Gene', header: 'Channel 3-Gene' },
      { field: 'channel3File', header: 'Channel 3-File' },
      { field: 'channel3Dye', header: 'Channel 3-Dye' },
      { field: 'channel4Gene', header: 'Channel 4-Gene' },
      { field: 'channel4File', header: 'Channel 4-File' },
      { field: 'channel4Dye', header: 'Channel 4-Dye' },
      { field: 'channel5Gene', header: 'Channel 5-Gene' },
      { field: 'channel5File', header: 'Channel 5-File' },
      { field: 'channel5Dye', header: 'Channel 5-Dye' },
      { field: 'runProtocol', header: 'Run Protocol' },
      { field: 'dominantChannel', header: 'Dominant Channel' },
      { field: 'machineType', header: 'Machine Type' },
      { field: 'active', header: 'Active' }
    ]

    this.kitDetailCols = [
      { field: 'kitName', header: 'Kit Name' },
      { field: 'lab', header: 'Lab' },
      { field: 'kitType', header: 'Kit Type' },
      { field: 'requiredMaterials', header: 'Required Materials' },
      { field: 'swabRestriction', header: 'Swab Restriction' },
      { field: 'channel1Gene', header: 'Channel 1-Gene' },
      { field: 'channel1File', header: 'Channel 1-File' },
      { field: 'channel1Dye', header: 'Channel 1-Dye' },
      { field: 'channel2Gene', header: 'Channel 2-Gene' },
      { field: 'channel2File', header: 'Channel 2-File' },
      { field: 'channel2Dye', header: 'Channel 2-Dye' },
      { field: 'channel3Gene', header: 'Channel 3-Gene' },
      { field: 'channel3File', header: 'Channel 3-File' },
      { field: 'channel3Dye', header: 'Channel 3-Dye' },
      { field: 'channel4Gene', header: 'Channel 4-Gene' },
      { field: 'channel4File', header: 'Channel 4-File' },
      { field: 'channel4Dye', header: 'Channel 4-Dye' },
      { field: 'channel5Gene', header: 'Channel 5-Gene' },
      { field: 'channel5File', header: 'Channel 5-File' },
      { field: 'channel5Dye', header: 'Channel 5-Dye' },
      { field: 'runProtocol', header: 'Run Protocol' },
      { field: 'dominantChannel', header: 'Dominant Channel' },
      { field: 'machineType', header: 'Machine Type' },
      { field: 'processingTime', header: 'Processing Time' },
      { field: 'active', header: 'Active' }
    ]

    //values to be displayed in Max redo dropdown in crud table component
    this.maxRedoValues = [
      { label: '0', value: 0 },
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: 3 },
    ];

    this.reactionOptionValues = [
      { label: 'Standard', value: 'Standard' },
      { label: 'GCRich', value: 'GCRich' },
      { label: 'BisulfitSample', value: 'BisulfitSample' }
    ]

    this.problemCategoriesCols = [
      { field: 'categoryName', header: 'Category Name' },
      { field: 'displayName', header: 'Display Name' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'active', header: 'Active' }
    ];

    this.problemCols = [
      { field: 'problemName', header: 'Problem' },
      { field: 'category', header: 'Category' },
      { field: 'description', header: 'Description' },
      { field: 'severity', header: 'Severity' },
      { field: 'extProblemCode', header: 'Ext Problem Code' },
      { field: 'standardCode', header: 'Standard Code' },
      { field: 'active', header: 'Active' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' }
    ];


    this.resultProcessCols = [
      { field: 'name', header: 'Process Name' },
      { field: 'mergeGroup', header: 'Merge Group' },
      { field: 'rawDataRequired', header: 'Transfer Raw Data' },
      { field: 'resultFileRequired', header: 'Transfer Result File' },
      { field: 'reportRequired', header: 'Transfer Report' },
      { field: 'metaDataFileRequired', header: 'Meta File Required' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'storageType', header: 'Storage Type' },
      { field: 'storageKey', header: 'Storage Key' },
      { field: 'storageDetail', header: 'Storage Detail' },
      { field: 'containerName', header: 'Container Name' },
      { field: 'active', header: 'Active' }
    ];

    this.resultEngineConfigCols = [
      { field: 'kitName', header: 'Kit Name' },
      { field: 'cycler', header: 'Cycler' },
      { field: 'resultName', header: 'Result Name' },
      { field: 'active', header: 'Active' }
    ];

    this.externalSenderLoginCols = [
      { field: 'puid', header: 'PUID' },
      { field: 'name', header: 'Sender Name' }
    ]

    this.tagCols = [
      { field: 'tagPlateName', header: 'Tag Plate Name' },
      { field: 'lab', header: 'Lab', display: 'none' },
      { field: 'serviceIdentifier', header: 'Service Identifier' },
      { field: 'tagSystem', header: this.TAG_SYSTEM },
      { field: 'tagPlateBarcode', header: 'Active Plate Barcodes' },
      { field: 'runPlanningSequence', header: 'Run Planning Sequence' },
      { field: 'active', header: 'Active' }
    ];

    this.tagSystemCols = [
      { field: 'tagSystemName', header: 'Tag System Name', sort: 'tagSystemName' },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'serviceIdentifier', header: 'Service Identifier' },
      { field: 'active', header: 'Active' }
    ];

    this.snpProfileCols = [
      { field: 'snpProfileName', header: "SNP Profile Name" },
      { field: 'profileLength', header: "Upload SNPs" },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'requiredPercentage', header: "Single Required Markers" },
      { field: 'compatibleUntil', header: "Single Compatible Until" },
      { field: 'incompatibleAbove', header: "Single Incompatible Above" },
      { field: 'requiredPercentageBoth', header: "Both Required Markers" },
      { field: 'compatibleUntilBoth', header: "Both Compatible Until" },
      { field: 'incompatibleAboveBoth', header: "Both Incompatible Above" },
      { field: 'byExaminePanel', header: "Examine By Panel" },
      { field: 'active', header: "Active" },
    ];

    this.flowCellCols = [
      { field: 'flowCellName', header: "Configuration Name" },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'sequencer', header: "Sequencer" },
      { field: 'flowCellType', header: "Flow Cell Type" },
      { field: 'flowCellMode', header: "Flow Cell Mode" },
      { field: 'physicalLanes', header: "Physical lanes" },
      { field: 'logicalLanes', header: "Logical lanes" },
      { field: 'totalCapacity', header: "Total Capacity" },
      { field: 'laneCapacity', header: "Lane Capacity" },
      { field: 'capabilities', header: "capabilities", display: 'none' },
      { field: 'active', header: "Active" }
    ];

    this.analysisCols = [
      { field: 'analysisName', header: "Analysis Name" },
      { field: 'pipelineName', header: 'Pipeline Name' },
      { field: 'versionOfAnalysis', header: "Version" },
      { field: 'sequencer', header: "Sequencer" },
      { field: 'constraint', header: "constraint", display: 'none' },
      { field: 'product', header: "Product" },
      { field: 'productId', header: "Product Id" },
      { field: 'mismatch', header: "Mismatch" },
      { field: 'limsUpload', header: "LimsUpload" },
      { field: 'autoAnalysis', header: "AutoAnalysis" },
      { field: 'reanalysis', header: "Reanalysis" },
      { field: 'indexAnalysis', header: "IndexAnalysis" },
      { field: 'ignoreMissingFiles', header: "IgnoreMissingFiles" },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'active', header: "Active" }
    ];

    this.processCols = [
      { field: 'name', header: "Process" },
      { field: 'processType', header: this.PROCESS_TYPE },
      { field: 'tagSystemName', header: this.TAG_SYSTEM },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'active', header: "Active" }
    ];

    this.processTypeCols = [
      { field: 'name', header: this.PROCESS_TYPE },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'active', header: "Active" }
    ];

    this.stationCols = [
      { field: 'name', header: "Station" },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'active', header: "Active" }
    ];

    this.inBoundFileCols = [
      { field: 'name', header: "Name" },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'handler', header: "Handler" },
      { field: 'machine', header: "Machine" },
      { field: 'regexRunID', header: "RegEx for MachineRunId" },
      { field: 'location', header: "Location" },
      { field: 'autoProcessing', header: "Auto-Processing" },
      { field: 'active', header: "Active" }
    ];

    this.libConfigCols = [
      { field: 'name', header: "Name" },
      { field: 'process', header: 'Process' },
      { field: 'entryQcFAAssayType', header: "Entry QC-FA assay Type" },
      { field: 'entryQCMinConc', header: "Entry QC-min conc (ng/µl)" },
      { field: 'entryQCMaxConc', header: "Entry QC-max conc (ng/µl)" },
      { field: 'entryQCTargetVolume', header: "Entry QC-Target volume (µl)" },
      { field: 'defaultAmountToStartTheLibPrep', header: 'Default Amount to start the Lib Prep' },
      { field: 'entryQCMinDNARNAAmount', header: "EntryQC - min amount (ng)" },
      { field: 'entryQCMinDQNRQN', header: "Entry QC-min DQN/RQN" },
      { field: 'libQCMinMolarity', header: "LibQC - min molarity (nm)" },
      { field: 'libQCMinSize', header: "LibQC - min size (bp)" },
      { field: 'libQCMaxSize', header: "LibQC - max size (bp)" },
      { field: 'defaultValue', header: "Default" },
      { field: 'active', header: "Active" }
    ]
    this.workFilesCols = [
      { field: 'workFileDefintionName', header: "Workfile Definition Name" },
      { field: 'fileName', header: "File Name" },
      { field: 'fileFormat', header: "File Format" },
      { field: 'processName', header: "Process" },
      { field: 'stepDisplayName', header: this.PROCESS_STEP },
      { field: 'active', header: "Active" },
      { field: 'continueWithFileConfig', header: "User Config" }
    ];

    this.stepCategoryCols = [
      { field: 'stepCategoryName', header: "Step Category Name" },
      { field: 'lab', header: 'Lab', sort: 'lab.name' },
      { field: 'active', header: "Active" }
    ];
    //Service methods
    this._masterDataService.getCountries().subscribe(results => {
      if (!results) {
        return;
      }
      this.countries = results.data;
    });

    this._masterDataService.getLabs(false).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.labs = results.data;
        this.labs.forEach(function (lab) {
          if (lab.mix2SeqLabId === 0) {
            lab.mix2SeqLabId = null;
          }
        })
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    );

    this._masterDataService.getBusinessAreas(true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Active business Areas:", results.data);
        this.baOptions = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    );
    this._masterDataService.getLabs(true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Active labs:", results.data);
        this.labOptions = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    );
    this._masterDataService.getMachineTypes(true, this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Active machine types:", results.data);
        this.machineTypesOptions = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    );

    this._masterDataService.getBmsProductName().subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("BMS Product names:", results.data);
        this.bmsProductNames = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    );

    this._masterDataService.getPrinters(this.selectedLab.lab._id, true).subscribe({
      next: (results) => {
        if (!results) {
          return;
        }
        console.log("Active printers:", results.data);
        this.printerOptions = results.data;
      },
      error: (error) => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    });
    this._masterDataService.getProducts(true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Active Products:", results.data);
        this.productOptions = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );

    this._masterDataService.getWorkFlows(this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.workFlowOptions = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );

    this.getFlowCellMDMData();
    this.getAnalysisMDMData();
    this.getProcessMDMData();
    this.getProcessTypeMDMData();
    this.getStationMDMData();
    this.getWorkfileMDMData();
    this.getStepCategoryMDMData();
    this.getActiveStepCategories();

    this._masterDataService.getActiveBufferChemicals(true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Active Buffer chemicals:", results.data);
        this.bufferChemicalOptions = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    );

  }

  setColor(status) {
    if (status == 200) {
      return "up"
    } else if (status == 503) {
      return "down"
    } else {
      return null
    }
  }
  private handleError(error: any) {
    this.loading = false
    const message = this.errorHandler.handleError(error);
    this._messageService.addErrorMessage(message);
  }


  getFlowCellMDMData() {
    this._masterDataService.getFlowCells(this.selectedLab.lab._id).subscribe(
      flowCellDataList => {
        if (!flowCellDataList) {
          return;
        }
        this.flowCell = flowCellDataList.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }


  getAnalysisMDMData() {
    this._masterDataService.getAnalysis(this.selectedLab.lab._id).subscribe(
      analysisDataList => {
        if (!analysisDataList) {
          return;
        }
        this.analysis = analysisDataList.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getProcessMDMData() {
    this._masterDataService.getProcessData(this.selectedLab.lab._id).subscribe(
      processList => {
        if (!processList) {
          return;
        }
        this.process = processList.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );


  }

  getProcessTypeMDMData() {
    this._masterDataService.getProcessTypeData(this.selectedLab.lab._id).subscribe(
      processTypeList => {
        if (!processTypeList) {
          return;
        }
        this.processType = processTypeList.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getStationMDMData() {
    this._masterDataService.getStationData(this.selectedLab.lab._id).subscribe(
      stationList => {
        if (!stationList) {
          return;
        }
        this.station = stationList.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getWorkfileMDMData() {
    this._masterDataService.getWorkfileData(this.selectedLab.lab._id).subscribe(
      workfileList => {
        if (!workfileList) {
          return;
        }
        this.workFiles = workfileList.data;
        this.loading = false;
      },
      error => {
        this.loading = false;
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }
  getStepCategoryMDMData() {
    this._masterDataService.getStepCategoryList(this.selectedLab.lab._id).subscribe(
      stepCategoryList => {
        if (!stepCategoryList) {
          return;
        }
        this.stepCategories = stepCategoryList.data;
        this.loading = false;
      },
      error => {
        this.handleError(error);
      }
    );
  }
  getInBoundData() {
    this._masterDataService.getInboundFileData(this.selectedLab.lab._id).subscribe(
      inBoundList => {
        if (!inBoundList) {
          return;
        }
        this.inBoundFile = inBoundList.data;
        this.loading = false;
      },
      error => {
        this.loading = false;
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getLibraryConfigurationData() {
    this._masterDataService.getLibrarayConfigurationData(this.selectedLab.lab._id).subscribe(
      libConfigList => {
        if (!libConfigList) {
          return;
        }
        this.libConfigFile = libConfigList.data;
        this.loading = false;
      },
      error => {
        this.loading = false;
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
    this._masterDataService.getActiveProcessData(this.selectedLab.lab._id).subscribe(
      processList => {
        if (!processList) {
          return;
        }
        this.processOptions = processList.data;

      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );

  }
  getActiveStepCategories() {
    this.processStepOptions = [];
    this._masterDataService.getStepCategoryActiveList(this.selectedLab.lab._id).subscribe(
      results => {
        if (!results) {
          return;
        }
        results.data.forEach(element => {
          this.processStepOptions.push({ label: element.stepCategoryName, value: element.stepCategoryName });
        });
        this.loading = false;
      },
      error => {
        this.handleError(error);
      }
    );
  }

  getBusinessAreas() {
    this._masterDataService.getBusinessAreas(false).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("business Areas:", results.data);
        this.businessAreas = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getSelectedLab() {
    if (this.selectedLab) {
      this._masterDataService.getLabsBasedOnSelectedLabForAppliedGenomics(this.selectedLab.lab).subscribe(
        results => {
          if (!results) {
            return;
          }
          console.log("labs:", results.data);
          this.labs = results.data;
          this.labs.forEach(function (lab) {
            if (lab.mix2SeqLabId === 0) {
              lab.mix2SeqLabId = null;
            }
          })
        },
        error => {
          const message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);

        }
      );

    } else {
      this._masterDataService.getLabs(false).subscribe(
        results => {
          if (!results) {
            return;
          }
          console.log("labs:", results.data);
          this.labs = results.data;
          this.labs.forEach(function (lab) {
            if (lab.mix2SeqLabId === 0) {
              lab.mix2SeqLabId = null;
            }
          })
        },
        error => {
          const message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);

        }
      );
    }
  }

  getMachineTypes() {
    this._masterDataService.getMachineTypes(false, this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("MachineTypes:", results.data);
        this.machineTypes = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getMachines() {
    this._masterDataService.getMachines(this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("machines:", results.data);
        this.machines = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getPrinters() {
    this._masterDataService.getPrinters(this.selectedLab.lab._id, false).subscribe({
      next: (results) => {
        if (!results) {
          return;
        }
        console.log("Printers:", results.data);
        this.printers = results.data;
      },
      error: (error) => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    });
  }

  getCarrierStates() {
    this._masterDataService.getCarrierStatesActive(this.selectedLab.lab._id, false).subscribe({
      next: (results) => {
        if (!results) {
          return;
        }
        this.states = results.data;
      },
      error: (error) => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    });
  }

  getSeqConfigs() {
    this._masterDataService.getSeqConfigs().subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Seq Configs:", results.data);
        this.seqConfigs = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getProducts() {
    this._masterDataService.getProducts(false).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("The products:", results.data);
        this.products = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getChemicals() {
    this._masterDataService.getChemicals().subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Chemicals:", results.data);
        this.chemicals = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getHealthStatus() {
    this._masterDataService.getHealthStatus().subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Health:", results);
        this.respose = results;
        this.health = this.respose.payload.dependency;
        this.loading = false;
      },
      error => {
        console.log("Health:", error);
        this.respose = error.error;
        this.health = this.respose.payload.dependency;
        /* This isnt neccessary due to seeing the error status on page
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        */
        this.loading = false;
      }
    );
  }

  getAccessLog() {
    this._masterDataService.getAccessLog().subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Access Log:", results.data);
        this.accessLog = results.data;
      },
      error => {
        console.log("No Logs Found")
        this.accessLog = [];
      }

    );
  }

  getEchoCofigs() {
    this._masterDataService.getEchoCofigs(false).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Active Echo Configs --> :", results.data);
        this.echoConfigs = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getSalesItemType() {
    this._masterDataService.getSalesItemType().subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Sales item type configuration --> :", results.data);
        this.sitConfigs = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getStandardPrimer() {
    this._masterDataService.getStandardPrimer().subscribe(
      results => {
        if (!results) {
          return;
        }
        this.standardPrimers = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getTemplates() {
    this._masterDataService.getTemplates(this.selectedLab.lab._id).subscribe({
      next: (results) => {
        if (!results) {
          return;
        }
        console.log("Templates :", results.data);
        this.templates = results.data;
      },
      error: (error) => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    });
  }

  getSenders() {
    this._masterDataService.getSenders(this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Templates :", results.data);
        this.senders = results.data;
        this.loading = false
      },
      error => {
        this.templates = [];
        this.handleError(error);
      }
    );
  }

  getKits() {
    this._masterDataService.getKits(this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Templates kit :", results.data);
        this.kits = results.data;
      },
      error => {
        this.templates = [];
        console.log("Templates kit:", error);
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getProblemCategoriesList() {
    this._masterDataService.getProblemCategoriesList(this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.problemCategories = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getProblemList() {
    this._masterDataService.getProblemList(this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.problem = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getResultProcessList() {
    this._masterDataService.getResultProcessList(this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.resultProcess = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getResultConfigList() {
    this._masterDataService.getResultConfigList(this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.resultConfigList = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getManufacturerList() {
    this._masterDataService.getManufacturerList(this.selectedLab.lab._id).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.manufacturersList = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getExternalSenderLogins() {
    this._masterDataService.getExternalSenderLogins(this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.externalSenderLogins = results.data;
        this.loading = false
      },
      error => {
        this.templates = [];
        this.handleError(error);
      }
    );
  }

  getTagsystem() {
    this._masterDataService.getTagsystem(this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.tagSystem = results.data;
        this.loading = false
      },
      error => {
        this.handleError(error);
      }
    );
  }

  getTags() {
    this._masterDataService.getTags(this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.tags = results.data;
        this.loading = false
      },
      error => {
        this.handleError(error);
      }
    );
    this._masterDataService.getMapOfTags(this.selectedLab.lab._id, null).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.mapOfTags = new Map(Object.entries(results.data));
        this.tagPlates = Array.from(this.mapOfTags.keys())
        this.loading = false
      },
      error => {
        this.handleError(error);
      }
    );
  }

  getWorkFlows() {
    this._masterDataService.getWorkFlows(this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.workFlow = results.data;
        this.loading = false
      },
      error => {
        this.handleError(error);
      }
    );
  }

  getSNPProfiles() {
    this._masterDataService.getSNPProfiles(this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.snpProfile = results.data;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  onDropdownChange(event: any) {
    switch (event.value) {
      case this.BUSINESS_AREAS: {
        this.getBusinessAreas();
        break;
      }
      case "Labs": {
        this.getSelectedLab();
        break;
      }
      case this.MACHINE_TYPE: {
        this.getMachineTypes();
        break;
      }
      case "Machines": {
        this.getMachines();
        break;
      }
      case "Printers": {
        this.getPrinters();
        break;
      }
      case this.PROCESS_STEP : {
        this.getCarrierStates();
        this.getActiveStepCategories();
        break;
      }
      case this.SEQUENCER_CONFIGURATION: {
        this.getSeqConfigs();
        break;
      }
      case "Products":
      {
        this.getProducts();
        break;
      }
      case "Chemicals": {
        this.getChemicals();
        break;
      }
      case "Health": {
        this.loading = true;
        this.getHealthStatus();
        break;
      }
      case "Access Logs": {
        this.getAccessLog();
        break;
      }
      case "LibTypes": {
        this.loading = true
        this.getLibraryConfigurationData();
        break;
      }
      case this.ECHO_CONFIGURATINS: {
        this.getEchoCofigs();
        break;
      }

      case this.SALES_ITEM_TYPES: {
        this.getSalesItemType();
        break;
      }

      case this.STANDARD_PRIMERS: {
        this.getStandardPrimer()
        break;
      }
      case this.BARCODE_TEMPLATES: {
        this.getTemplates();
        break;
      }
      case "Senders": {
        this.loading = true
        this.getSenders();
        break;
      }

      case "Kits": {
        this.getKits();
        break;
      }

      case this.PROBLEM_CATEGORY: {
        this.getProblemCategoriesList();
        break;
      }
      case "QC Problem": {
        this.getProblemList();
        break;
      }
      case this.RESULT_PROCESS: {
        this.getResultProcessList();
        break;
      }
      case this.RESULT_LOGIC: {
        this.getResultConfigList();
        break;
      }
      case this.MACHINE_MANUFACTURER: {
        this.getManufacturerList();
        break;
      }
      case this.SENDER_EXTERNAL_CONFIGURATIONS: {
        this.loading = true
        this.getExternalSenderLogins();
        break;
      }

      case this.TAG_SYSTEM: {
        this.loading = true
        this.tagSystem = [];
        this.getTagsystem();
        break;
      }

      case this.TAG_PLATES: {
        this.loading = true
        this.tags = [];
        this.getTags();
        break;
      }

      case "Work Flow":
      {
        this.loading = true
        this.getWorkFlows();
        break;
      }

      case this.SNP_PROFILE:
      {
        this.getSNPProfiles();
        break;
      }

      case this.FLOW_CELLS:
      {
        this.getFlowCellMDMData();
        break;
      }

      case "Analysis":
      {
        this.getAnalysisMDMData();
        break;
      }

      case "Process":
      {
        this.getProcessMDMData();
        break;
      }

      case this.PROCESS_TYPE:
      {
        this.getProcessTypeMDMData();
        break;
      }

      case "Station":
      {
        this.getStationMDMData();
        break;
      }
      case this.INBOUND_FILE_PROCESSING:
      {
        this.loading = true
        this.getInBoundData();
        break;
      }
      case "Workfiles":
      {
        this.loading = true
        this.getWorkfileMDMData();
        break;
      }
      case this.STEP_CATEGORY:
      {
        this.loading = true
        this.getStepCategoryMDMData();
        break;
      }
    }
  }
}
